<template>
  <button
    type="button"
    @click="toggleLanguage"
    :class="[
      'flex items-center justify-center w-9 h-9 rounded-md border transition-all duration-300',
      'hover:bg-surface-100 dark:hover:bg-surface-800',
      'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1',
      'text-surface-700 dark:text-surface-300',
      'bg-surface-0 dark:bg-surface-950'
    ]"
    :title="`Switch to ${getCurrentLanguage().code === 'en' ? 'Arabic (العربية)' : 'English'}`"
    :aria-label="`${getOppositeLanguageFlag()} ${getOppositeLanguageName()}. Switch to ${getOppositeLanguageName()}.`"
  >
    <!-- Flag Icon with smooth transition - Shows opposite language flag -->
    <span 
      class="text-lg leading-none transition-transform duration-300"
      :class="[
        'transform',
        getCurrentLanguage().code === 'ar' ? 'scale-110' : 'scale-100'
      ]"
    >
      {{ getOppositeLanguageFlag() }}
    </span>
  </button>
</template>

<script setup>
import { useDirection } from '@/composables/useDirection'
import { useLanguageStore } from '@/stores/language'

const {
  toggleLanguage,
  getCurrentLanguage
} = useDirection()

const languageStore = useLanguageStore()

// Function to get the opposite language flag
const getOppositeLanguageFlag = () => {
  const currentLang = getCurrentLanguage()
  const oppositeLanguageCode = currentLang.code === 'en' ? 'ar' : 'en'
  return languageStore.languages[oppositeLanguageCode].flag
}

const getOppositeLanguageName = () => {
  return getCurrentLanguage().code === 'en' ? 'Arabic' : 'English'
}
</script>

<style scoped>
/* Ensure smooth transitions */
button {
  transition: all 0.3s ease;
}

button:hover span {
  transform: scale(1.1);
}
</style>
